module.exports = __webpack_public_path__ + "img/assetbundles.2e9406eb.png";